import { BackButtonT1 } from "Components/Common/Button/index";
import { Spacer } from "Components/Common/Spacer/index";
import { TypographyT32 } from "Components/Common/Typography/index";
import {
  FlexWrapperT1,
  FlexWrapperT8,
} from "Components/Common/Wrapper/FlexWrapper";
import { PageWrapperT3 } from "Components/Common/Wrapper/PageWrapper";
import React, { Component, Fragment } from "react";
import styled from "@emotion/styled";
import BasicDetails from "Components/RateComparison/CalculationForFreight/BasicDetails";
import FreightCalculationInfo from "Components/RateComparison/CalculationForFreight/FreightCalculationInfo";
import { WrapperT2 } from "Components/Common/Wrapper/index";
import HeaderInfoDetails from "Components/RateComparison/CalculationForFreight/HeaderInfoDetails";
import Rupees from "Components/RateComparison/CalculationForFreight/Rupees";
import { withRouter } from "react-router";
import ModalT1 from "Components/Common/Modal/ModalT1";
import ModalCardT1 from "Components/RateComparison/CalculationForFreight/ModalCardT1";
import RFQInformationTable from "Components/RateComparison/CalculationForFreight/RFQInformationTable";
import { connect } from "react-redux";
import { getToFixedValue } from "Utils/index";

class DetailedCalculationForFreight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExtraChargeAccordionOpen: false,
      isModalPopupOpen: false,
    };
  }

  handleOnClickBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  handleIsExtraChargeAccordionOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isExtraChargeAccordionOpen: !previousState.isExtraChargeAccordionOpen,
      };
      return updatepreviousState;
    });
  };

  handleModalPopupOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: true,
      };
      return updatepreviousState;
    });
  };

  handleModalPopupClose = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: false,
      };
      return updatepreviousState;
    });
  };

  getRouteDetails = () => {
    const { detailedCalculationForRailFreight } = this.props;

    const C1 = !!detailedCalculationForRailFreight.from;

    if (C1) {
      const routeDetails = `
      ${detailedCalculationForRailFreight.from} - 
      ${detailedCalculationForRailFreight.origin_yard} - 
      ${detailedCalculationForRailFreight.destination_yard} - 
      ${detailedCalculationForRailFreight.to} 
      `;
      return routeDetails;
    }

    return "No Data";
  };

  getDetails = () => {
    const { detailedCalculationForRailFreight } = this.props;
    const C1 = Array.isArray(detailedCalculationForRailFreight.details);
    if (C1) {
      const details = detailedCalculationForRailFreight.details[0] || {};
      return details;
    }
    return {};
  };

  getFirstMileDetails = () => {
    const { detailedCalculationForRailFreight } = this.props;
    const C1 = Array.isArray(detailedCalculationForRailFreight.bids);
    if (C1) {
      const firstMileDetails = detailedCalculationForRailFreight.bids[0] || {};
      return firstMileDetails;
    }
    return {};
  };

  getLastMileDetails = () => {
    const { detailedCalculationForRailFreight } = this.props;
    const C1 = Array.isArray(detailedCalculationForRailFreight.bids);
    if (C1) {
      const firstMileDetails = detailedCalculationForRailFreight.bids[1] || {};
      return firstMileDetails;
    }
    return {};
  };

  render() {
    const { isExtraChargeAccordionOpen, isModalPopupOpen } = this.state;
    const { detailedCalculationForRailFreight } = this.props;
    console.log(
      "detailedCalculationForRailFreight:",
      detailedCalculationForRailFreight
    );
    return (
      <Fragment>
        <PageWrapperT3>
          <ModalT1
            isOpenState={isModalPopupOpen}
            handleOnClickForClose={this.handleModalPopupClose}
          >
            <ModalCardT1 title={"Average Calculation for Hazira To Lucknow"}>
              <RFQInformationTable />
            </ModalCardT1>
          </ModalT1>
          <FlexWrapperT1>
            {/* <BackButtonT1 onClick={this.handleOnClickBack} /> */}
            <TypographyT32>{this.getRouteDetails()}</TypographyT32>
          </FlexWrapperT1>
          <Spacer spacing={"15px"} />
          <CardWrapper>
            <HeaderInfoDetails
              rate={
                <Rupees
                  // rate={getToFixedValue(detailedCalculationForRailFreight.sum_of_bid_price,2)}
                  rate={getToFixedValue(detailedCalculationForRailFreight.sum_of_railway_price,2)}
                />
              }
              variationRate={"-804"}
            />
            <Spacer spacing={"8px"} />
            <FlexWrapperT8>
              <WrapperT2>
                <BasicDetails details={this.getDetails()} />
              </WrapperT2>
              <WrapperT2>
                <FreightCalculationInfo
                  isExtraChargeAccordionOpen={isExtraChargeAccordionOpen}
                  handleIsExtraChargeAccordionOpen={
                    this.handleIsExtraChargeAccordionOpen
                  }
                  handleModalPopupOpen={this.handleModalPopupOpen}
                  details={this.getDetails()}
                  firstMileDetails={this.getFirstMileDetails()}
                  lastMileDetails={this.getLastMileDetails()}
                  sum_rail_freight_yard={
                    detailedCalculationForRailFreight.sum_rail_freight_yard
                  }
                  total_rail_freight={
                    detailedCalculationForRailFreight.total_rail_freight
                  }
                />
              </WrapperT2>
            </FlexWrapperT8>
          </CardWrapper>
        </PageWrapperT3>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("state:", state);
  return {
    // loaderT1: !!state.common.loaderT1,
    detailedCalculationForRailFreight:
      state.rateComparison.detailedCalculationForRailFreight,
  };
};

export default connect(mapStateToProps)(
  withRouter(DetailedCalculationForFreight)
);

const CardWrapper = styled.div`
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(82, 138, 234, 0.24);
  padding: 15px;
`;
